import React from "react";
import Products from './Products';
import GridCarousel from './GridCarousel';
import FlashDeals from './FlashDeals';
import slider1 from '../../assets/img/slider/slider-1.svg';
import slider2 from '../../assets/img/slider/slider-2.jpg';
import slider3 from '../../assets/img/slider/slider-3.jpg';
import { Carousel } from 'react-responsive-carousel';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

function Home() {
    return (
        <>
            {/* ── Hero Carousel ── */}
            <div className="slider" data-autoplay="true" data-autoplay-speed="4000">
                <Carousel
                    showArrows={false}
                    showThumbs={false}
                    showStatus={false}
                    autoPlay={true}
                    interval={3000}
                    transitionTime={500}
                    infiniteLoop
                >
                    <div><img src={slider1} alt="Slide 1" /></div>
                    <div><img src={slider2} alt="Slide 2" /></div>
                    <div><img src={slider3} alt="Slide 3" /></div>
                </Carousel>
            </div>

            {/* ── Categories ── */}
            <div className="pt-5">
                <div className="container-fluid theme-container">
                    <GridCarousel />
                </div>
            </div>

            {/* ── Flash Deals ── */}
            <HomeSection>
                <div className="container-fluid theme-container">
                    <SectionHeader>
                        <div className="sh-title-group">
                            <span className="sh-accent" />
                            <div>
                                <h5 className="sh-title">⚡ Flash Deals</h5>
                                <p className="sh-sub">Limited time offers — grab them fast</p>
                            </div>
                        </div>
                        <Link to="/category" className="sh-see-all">
                            See All &nbsp;<i className="fa fa-arrow-right" />
                        </Link>
                    </SectionHeader>
                    <FlashDeals />
                </div>
            </HomeSection>

            {/* ── Deals of the Day ── */}
            <Products />
        </>
    );
}

export default Home;

/* ── Styled ── */

const HomeSection = styled.div`
    padding: 48px 0 40px;
    background: linear-gradient(180deg, #f0f4ff 0%, #ffffff 100%);
`;

const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 28px;
    flex-wrap: wrap;
    gap: 12px;

    .sh-title-group {
        display: flex;
        align-items: center;
        gap: 14px;
    }

    .sh-accent {
        display: block;
        width: 4px;
        height: 44px;
        background: linear-gradient(180deg, #2563eb, #7c3aed);
        border-radius: 4px;
        flex-shrink: 0;
    }

    .sh-title {
        font-size: 20px;
        font-weight: 700;
        color: #1e293b;
        margin: 0 0 2px;
        font-family: "Poppins", sans-serif;
        letter-spacing: -0.01em;
    }

    .sh-sub {
        font-size: 12.5px;
        color: #64748b;
        margin: 0;
    }

    .sh-see-all {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        font-size: 13px;
        font-weight: 600;
        color: #2563eb;
        border: 1.5px solid #bfdbfe;
        padding: 7px 16px;
        border-radius: 20px;
        text-decoration: none;
        transition: background 0.2s ease, color 0.2s ease;
        white-space: nowrap;
        font-family: "Poppins", sans-serif;

        &:hover {
            background: #2563eb;
            color: #fff;
            border-color: #2563eb;
        }
    }
`;
